import { render, staticRenderFns } from "./WageList.vue?vue&type=template&id=ca335a5e"
import script from "./WageList.vue?vue&type=script&lang=js"
export * from "./WageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports